import React, { useContext } from "react";
import "./confirm-alert.scss";
import classNames from "classnames";
import { useNavigate } from "react-router-dom";
import venomContext from "../../../context/venomContext";

export default function ConfirmAlert({
  setAlertIsActive,
  alertIsActive,
  Logout,
  setActionName,
  actionName,
  setAccountID,
  accountID,
}) {
  const navigate = useNavigate();
  const context = useContext(venomContext);
  const {
    deleteLoggedUser,
    deleteUserByAdmin,
    allBlogs,
    allCategories,
    getTotalUsers,
  } = context;
  const theme_color = localStorage.getItem("theme");
  return (
    <>
      <div
        className={classNames("confirm-alert", {
          active: alertIsActive === true,
        })}
      >
        <div className="alert-wrapper">
          <p>
            Are you sure you want to{" "}
            <span className={"text-" + theme_color}>{actionName}</span>
          </p>
          <div className="confirm-btns d-flex justify-content-end">
            <button
              className="btn btn-secondary btn-md me-2"
              onClick={() => {
                setAlertIsActive(false);
                setActionName("");
                setAccountID("");
              }}
            >
              Cancel
            </button>
            <button
              className={"btn btn-md btn-" + theme_color}
              onClick={() => {
                if (actionName === "logout") {
                  Logout();
                  navigate("/");
                  setAlertIsActive(false);
                } else if (actionName === "delete first admin account") {
                  deleteUserByAdmin(accountID);
                  setTimeout(async () => {
                    await allBlogs();
                    await allCategories();
                    await getTotalUsers();
                  }, 5000);
                  navigate("/");
                  setAlertIsActive(false);
                } else if (actionName === "delete admin account") {
                  deleteUserByAdmin(accountID);
                  setTimeout(async () => {
                    await allBlogs();
                    await allCategories();
                    await getTotalUsers();
                  }, 5000);
                  navigate("/");
                  setAlertIsActive(false);
                } else if (actionName === "delete user account") {
                  deleteUserByAdmin(accountID);
                  setTimeout(async () => {
                    await allBlogs();
                    await allCategories();
                    await getTotalUsers();
                  }, 5000);
                  setAlertIsActive(false);
                } else if (actionName === "delete account") {
                  deleteLoggedUser(accountID);
                  setTimeout(async () => {
                    await allBlogs();
                    await allCategories();
                    await getTotalUsers();
                  }, 5000);
                  navigate("/");
                  setAlertIsActive(false);
                }
              }}
            >
              Confirm
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
